import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import Downloads from "../components/downloadsPage/Downloads";

function DownloadsPage() {
  return (
    <TailwindPageWrapper>
      <Downloads />
    </TailwindPageWrapper>
  );
}
export default DownloadsPage;